import React, { createContext, useContext, useState, useEffect } from 'react';
import { defaultVideos, defaultLiveSettings, defaultAds } from '../data/seed';

const StoreContext = createContext();

export const useStore = () => useContext(StoreContext);

export const StoreProvider = ({ children }) => {
  const [user, setUser] = useState({ isLoggedIn: false, isSubscribed: false });
  const [isAdmin, setIsAdmin] = useState(false);

  // Using localStorage as a temporary mock backend before migrating to NoCode
  const [videos, setVideos] = useState(() => {
    const saved = localStorage.getItem('rocket_videos_v4');
    return saved ? JSON.parse(saved) : defaultVideos;
  });

  const [liveSettings, setLiveSettings] = useState(() => {
    const saved = localStorage.getItem('rocket_live_v4');
    return saved ? JSON.parse(saved) : defaultLiveSettings;
  });

  const [ads, setAds] = useState(() => {
    const saved = localStorage.getItem('rocket_ads_v4');
    return saved ? JSON.parse(saved) : defaultAds;
  });

  useEffect(() => localStorage.setItem('rocket_videos_v4', JSON.stringify(videos)), [videos]);
  useEffect(() => localStorage.setItem('rocket_live_v4', JSON.stringify(liveSettings)), [liveSettings]);
  useEffect(() => localStorage.setItem('rocket_ads_v4', JSON.stringify(ads)), [ads]);

  const loginUser = () => setUser(prev => ({ ...prev, isLoggedIn: true }));
  const subscribeUser = () => setUser({ isLoggedIn: true, isSubscribed: true });
  const logoutUser = () => setUser({ isLoggedIn: false, isSubscribed: false });

  // Admin Authentication
  const loginAdmin = (pwd) => {
    if (pwd === 'Rocketalgo@123') {
      setIsAdmin(true);
      return true;
    }
    return false;
  };

  const logoutAdmin = () => setIsAdmin(false);

  // Video CRUD Operations (Mock Backend)
  const saveVideo = (video) => {
    if (video.id) {
      // Update
      setVideos(videos.map(v => v.id === video.id ? video : v));
    } else {
      // Create
      setVideos([...videos, { ...video, id: Date.now().toString() }]);
    }
  };

  const deleteVideo = (id) => {
    // Delete
    setVideos(videos.filter(v => v.id !== id));
  };

  return (
    <StoreContext.Provider value={{
      user, loginUser, subscribeUser, logoutUser,
      isAdmin, loginAdmin, logoutAdmin,
      videos, saveVideo, deleteVideo,
      liveSettings, setLiveSettings,
      ads, setAds
    }}>
      {children}
    </StoreContext.Provider>
  );
};